import { styled } from '@gogame/components';

export const BudgetLabel = styled('span')`
  display: block;
  min-width: ${({ minWidthValue }) => `${minWidthValue}px`};
  font-size: 16px;
`;
